import { render, staticRenderFns } from "./configuration-templates-synoptic-templates-modal-structure.vue?vue&type=template&id=5123e8b6&scoped=true&"
import script from "./configuration-templates-synoptic-templates-modal-structure.ts?vue&type=script&lang=ts&"
export * from "./configuration-templates-synoptic-templates-modal-structure.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-templates-synoptic-templates-modal-structure.scss?vue&type=style&index=0&id=5123e8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5123e8b6",
  null
  
)

export default component.exports